import React from "react";
import { Skeleton } from "primereact/skeleton";

const PaymentStatusLoader = () => {
    return (
        <div className="bg-slate-50 flex items-center justify-center px-4 py-10">
            <div className="w-100 bg-white rounded-3xl shadow-lg overflow-hidden">
                <div className="bg-slate-100 flex flex-col items-center py-10 px-6">
                    <Skeleton shape="circle" size="5rem" />
                    <Skeleton
                        width="18rem"
                        height="2rem"
                        className="mt-6"
                    />
                    <Skeleton
                        width="24rem"
                        height="1rem"
                        className="mt-4"
                    />
                </div>
                <div className="p-8 space-y-8">
                    <div className="border rounded-2xl p-6">
                        <Skeleton width="10rem" height="1.5rem" />
                        <Skeleton
                            width="100%"
                            height="1rem"
                            className="mt-4"
                        />
                        <Skeleton
                            width="85%"
                            height="1rem"
                            className="mt-3"
                        />
                        <Skeleton
                            width="65%"
                            height="1rem"
                            className="mt-3"
                        />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <Skeleton height="3.5rem" borderRadius="1rem" />
                        <Skeleton height="3.5rem" borderRadius="1rem" />
                    </div>
                    <div className="flex justify-center">
                        <Skeleton width="16rem" height="1rem" />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PaymentStatusLoader;